import './polyfills';
import ResizeObserverPolyfill from 'resize-observer-polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { useRoutes, BrowserRouter } from 'react-router-dom';
import routes from './routes';
import '@/assets/css/index.scss';
const rootNode = document.getElementById('app');
const root = rootNode ? ReactDOM.createRoot(rootNode) : null;

if (typeof ResizeObserver === 'undefined') {
  window.ResizeObserver = ResizeObserverPolyfill;
}

/**
 * 开发环境下注入vconsole
 */
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  import('vconsole')
    .then((module) => {
      // 获得module里面的导出类
      const VConsole = module && (module.default || module);
      if (!VConsole) return;
      const win = window as any;
      // 判断是否已有实例，防止重复创建实例
      if (win.__VCONSOLE_INSTANCE) return;
      // 创建VConsole实例
      try {
        win.__VCONSOLE_INSTANCE = new VConsole();
      } catch (e) {
        console.warn('vConsole instantiation failed:', e);
      }
    })
    .catch((err) => {
      console.warn('Failed to load vConsole:', err);
    });
}

function hideSkeleton(): void {
  const skeleton = document.getElementById('skeleton');
  if (skeleton) {
    skeleton.style.display = 'none';
  }
}

const App = function () {
  const routing = useRoutes(routes);

  useEffect(function () {
    hideSkeleton();
  }, []);

  return <>{routing}</>;
};

function showInitializationFailedMessage() {
  const failureMessage = document.createElement('div');
  failureMessage.textContent = '初始化失败';
  document.body.appendChild(failureMessage);
}

if (root) {
  root.render(
    <div className="root">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </div>
  );
} else {
  showInitializationFailedMessage();
}
